import React from "react";
import * as Scrivito from "scrivito";
import {
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import cx from "classnames";
import { Button, ProductListWithControls } from "components";
import { PROJECT_CONFIGURATOR_TAB_TYPES } from "variables";
import { useTranslate } from "hooks";
import { ProjectTreeList } from "./ProjectTreeList/ProjectTreeList";
import type { ProductListRefValue } from "interfaces/product/product.types";

type ProjectSummaryProps = {
  onRedirectToConfiguratorClick: () => void;
  productListRef: React.RefObject<ProductListRefValue | null>;
  activeTab: string;
  handleChangeActiveTab: (e: React.MouseEvent<HTMLElement>) => void;
};

export const ProjectSummary = Scrivito.connect(
  ({
    onRedirectToConfiguratorClick,
    productListRef,
    activeTab,
    handleChangeActiveTab,
  }: ProjectSummaryProps) => {
    const translate = useTranslate();

    return (
      <div className="bg-gray-100">
        <Container className="d-flex flex-column p-4 bg-white mb-4">
          <div className="d-flex justify-content-between align-items-center mb-4 pe-4">
            <h3 className="text-uppercase">{translate("PROJECT_SUMMARY")}</h3>
            <Button
              data-testid="ProjectSummary_edit-configuration-btn"
              onClick={onRedirectToConfiguratorClick}
            >
              {translate("PROJECT_ITEM_EDIT_CONFIGURATION")}
            </Button>
          </div>
          <div className="ps-4">
            <Nav
              tabs
              className="d-inline-flex border border-info p-1 rounded-3 me-auto mt-0"
            >
              <NavItem>
                <NavLink
                  id={PROJECT_CONFIGURATOR_TAB_TYPES.PRODUCT_LIST}
                  onClick={handleChangeActiveTab}
                  className={cx("rounded-1 cursor-pointer py-1 fs-18 lh-22", {
                    "bg-blue-300 text-white":
                      activeTab === PROJECT_CONFIGURATOR_TAB_TYPES.PRODUCT_LIST,
                    "text-blue-300":
                      activeTab !== PROJECT_CONFIGURATOR_TAB_TYPES.PRODUCT_LIST,
                  })}
                >
                  {translate.stringOnly("PROJECT_PRODUCT_LIST")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  id={PROJECT_CONFIGURATOR_TAB_TYPES.PROJECT_TREE}
                  onClick={handleChangeActiveTab}
                  className={cx("rounded-1 cursor-pointer py-1 fs-18 lh-22", {
                    "bg-blue-300 text-white":
                      activeTab === PROJECT_CONFIGURATOR_TAB_TYPES.PROJECT_TREE,
                    "text-blue-300":
                      activeTab !== PROJECT_CONFIGURATOR_TAB_TYPES.PROJECT_TREE,
                  })}
                >
                  {translate.stringOnly("PROJECT_SUMMARY_SIDEBAR_MY_STRUCTURE")}
                </NavLink>
              </NavItem>
            </Nav>
          </div>
          <TabContent
            activeTab={activeTab}
            className="px-4"
            style={{ height: "800px" }}
          >
            <TabPane tabId={PROJECT_CONFIGURATOR_TAB_TYPES.PRODUCT_LIST}>
              <ProductListWithControls
                hasSizeSwitcher
                productListRef={productListRef}
              />
            </TabPane>
            <TabPane tabId={PROJECT_CONFIGURATOR_TAB_TYPES.PROJECT_TREE}>
              <ProjectTreeList />
            </TabPane>
          </TabContent>
        </Container>
      </div>
    );
  },
);
